import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export const API = () => {
	const { logout, setShowLogin } = useAuth();
	const navigate = useNavigate();

	const api = axios.create({
		baseURL: `${process.env.REACT_APP_BACKEND_SERVICE_URL}/api`,
		withCredentials: true,
	});

	api.interceptors.request.use(
		(req) => {
			// Modify the request
			return req;
		},
		(error) => {
			// Handle request error
			return Promise.reject(error);
		}
	);

	api.interceptors.response.use(
		(res) => {
			// Modify the res data or handle it
			return res;
		},
		(error) => {
			// Handle response error globally
			console.log('Response error api', error);
			if (error.response.status === 401 || error.response.status === 403) {
				//Unauthorized access
				logout(); //Logout the user
				setShowLogin(true);
				navigate('/');
				//console log errors in dev only, errors are still returned for individual handling
				if (process.env.NODE_ENV === 'development') {
					console.log('Unauthorized User Logged out.');
				}
			}
			return Promise.reject(error);
		}
	);

	return api;
};

export const PHP = () => {
	const { logout, setShowLogin } = useAuth();
	const navigate = useNavigate();

	const php = axios.create({
		baseURL: `${process.env.REACT_APP_BACKEND_PHP_SERVICE_URL}/`,
		withCredentials: true,
	});

	php.interceptors.request.use(
		(req) => {
			// Modify the request
			return req;
		},
		(error) => {
			// Handle request error
			return Promise.reject(error);
		}
	);

	php.interceptors.response.use(
		(res) => {
			// Modify the res data or handle it
			return res;
		},
		(error) => {
			// Handle response error globally
			console.log('Response error php', error);
			if (error.response.status === 401 || error.response.status === 403) {
				//Unauthorized access
				logout(); //Logout the user
				setShowLogin(true);
				navigate('/');
			}
			return Promise.reject(error);
		}
	);

	return php;
};
